// extracted by mini-css-extract-plugin
module.exports = {"card":"StartPageCard-module-card--DNGYa","buttonBox":"StartPageCard-module-buttonBox--rCPfO","imageWrapper":"StartPageCard-module-imageWrapper--TaXuS"};